<template>
  <v-row class="mb-2">
    <v-col cols="12" md="6">
      <div class="v-label mb-2">تصویر فعلی</div>
      <div class="current-picture">
        <img v-if="current && !removed" :src="current" alt="">
        <div v-else class="current-picture__empty">
          <v-icon large color="#888">mdi-image-off</v-icon>
          <div>بدون تصویر</div>
        </div>
        <v-btn v-if="removable && current && !removed" class="current-picture__remove" small fab color="#fb4e4e"
               @click="remove">
          <v-icon color="white">mdi-trash-can</v-icon>
        </v-btn>
      </div>
    </v-col>
    <v-col cols="12" md="6">
      <div class="v-label mb-2">تصویر جدید</div>
      <image-uploader ref="uploader" :name="name" @filesReady="selected"></image-uploader>
      <div v-if="hint" class="picture-hint">{{ hint }}</div>
    </v-col>
  </v-row>
</template>

<script>
import ImageUploader from "@/components/File/ImageUploader.vue";

export default {
  name: "PictureField",

  components: {ImageUploader},

  props: {
    // Setting name, echoed back with each event.
    name: {type: String, required: true},
    current: {type: String, default: null},
    hint: {type: String, default: ''},
    removable: {type: Boolean, default: false},
  },

  data() {
    return {
      removed: false,
    }
  },

  watch: {
    current() {
      this.removed = false
      this.$refs.uploader?.reset()
    },
  },

  methods: {
    selected(file) {
      this.removed = false
      this.$emit('selected', file, this.name)
    },

    remove() {
      this.removed = true
      this.$refs.uploader?.reset()
      this.$emit('remove', this.name)
    },
  },
}
</script>

<style scoped>
.current-picture {
  position: relative;
  height: 250px;
  border-radius: 12px;
  overflow: hidden;
  background: #222831;
  border: 1px solid rgba(238, 238, 238, 0.12);
}

.current-picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.current-picture__empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #888;
}

.current-picture__remove {
  position: absolute;
  bottom: 12px;
  left: 12px;
}

.picture-hint {
  margin-top: 8px;
  font-size: 13px;
  color: #aaa;
}
</style>
